document.addEventListener('DOMContentLoaded', function() {
    const codeBlocks = document.querySelectorAll('.wp-block-brblocks-code-editor');
    codeBlocks.forEach(block => {
        const rawContent = block.getAttribute('data-code-content');
        const selectedScript = block.getAttribute('data-selected-script');

        // Tente un décodage base64 (nouveau format),
        // sinon utilise le contenu brut (ancien format)
        let codeContent = rawContent;
        try {
            const decoded = decodeURIComponent(escape(atob(rawContent)));
            if (decoded) codeContent = decoded;
        } catch (e) {
            // Ancien format : on utilise rawContent directement
        }

        if (!codeContent) return;

        if (selectedScript === 'css') {
            const style = document.createElement('style');
            style.textContent = codeContent;
            document.head.appendChild(style);
        } else if (selectedScript === 'javascript' || selectedScript === 'jquery') {
            const script = document.createElement('script');
            script.textContent = codeContent;
            document.body.appendChild(script);
        }
    });
});